import React from 'react'
import ConsentGate from './ConsentGate'

interface YouTubeEmbedProps {
  videoId: string
  title?: string
  aspectRatio?: '16:9' | '4:3'
  className?: string
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
  videoId,
  title = 'YouTube video',
  aspectRatio = '16:9',
  className = ''
}) => {
  const paddingBottom = aspectRatio === '16:9' ? '56.25%' : '75%'

  return (
    <ConsentGate
      type="google"
      serviceName="YouTube"
      controllerName="Google"
      description="YouTube uses cookies to track video views, personalize content recommendations, and may serve targeted advertising. Google may use this information for analytics and advertising across their services."
      className={className}
    >
      <div className={`my-6 ${className}`}>
        <div
          className="relative overflow-hidden rounded-lg shadow-lg"
          style={{ paddingBottom }}
        >
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube-nocookie.com/embed/${videoId}`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </ConsentGate>
  )
}

export default YouTubeEmbed